import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";

const socialMediaData = {
  facebook: [
    ["Name", "Month"],
    ["Aug", 250],
    ["Sep", 200],
    ["Oct", 900],
    ["Nov", 200],
    ["Dec", 800],
  ],
  instagram: [
    ["Name", "Month"],
    ["Aug", 370],
    ["Sep", 0],
    ["Oct", 700],
    ["Nov", 500],
    ["Dec", 600],
  ],
  Twitter: [
    ["Name", "Month"],
    ["Aug", 170],
    ["Sep", 200],
    ["Oct", 700],
    ["Nov", 500],
    ["Dec", 100],
  ],
  Linkedin: [
    ["Name", "Month"],
    ["Aug", 270],
    ["Sep", 600],
    ["Oct", 700],
    ["Nov", 900],
    ["Dec", 200],
  ],
  // Add more social media data arrays as needed (e.g., twitter, etc.)
};

const options = {
  chartArea: { width: "80%" },
  series: {
    0: { color: "#6842d9" }, // Color for Facebook
    1: { color: "#c32aa3" }, // Color for Instagram
    2: { color: "#1877f2" },
    // Add more colors for additional social media platforms as needed
  },
  bar: { groupWidth: "55%" },
  legend: { position: "top" },
  hAxis: {
    title: "",
  },
  vAxis: {
    title: "",
  },
};
const transformData = (originalData) => {
  const result = [
    [
      "Month",
      "Facebook",
      "Instagram",
      "Twitter",
      "Linkedin",
      "Youtube",
      "Qrcode",
      "Google",
      "Others",
    ],
  ];

  const sourceMap = {
    facebook: 1,
    instagram: 2,
    twitter: 3,
    linkedin: 4,
    youtube: 5,
    qrcode: 6,
    google:7,
    others: 8,
  };

  const dataMap = {};
  const filteredSource = originalData.filter(item => item !== null);
  filteredSource[0] && filteredSource.forEach(({ monthName, source }) => {
    if (!source || source.length === 0) {
      return;
    }

    const rowData = dataMap[monthName] || [monthName, 0, 0, 0, 0, 0, 0, 0,0];

    source.forEach(({ count, source: currentSourceName }) => {
      const formattedSourceName = currentSourceName
        ? currentSourceName.toLowerCase()
        : "others";

      if (sourceMap.hasOwnProperty(formattedSourceName)) {
        const index = sourceMap[formattedSourceName];
        rowData[index] += count;
      } else {
        rowData[sourceMap.others] += count;
      }
    });

    dataMap[monthName] = rowData;
  });

  Object.values(dataMap).forEach((rowData: any) => {
    result.push(rowData);
  });

  return result;
};

export function CompareChart(props: any) {
  const [socialMediaData, setSocialMediaData] = useState({});

  useEffect(() => {
    const transformedData = transformData(props?.list || []);
    // console.log(transformedData);

    setSocialMediaData(transformedData);
    // console.log(socialMediaData);
    
  }, [props?.list]);
  return (
    <Chart
      chartType="ColumnChart"
      width="100%"
      height="300px"
      legendToggle={true}
      data={socialMediaData}
      options={options}
    />
  );
}
